module.exports = __webpack_public_path__ + "img/instagram.12f5d2ab.svg";